import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import * as Highcharts from 'highcharts';

import { UserService } from 'BaseServices/user-service';
import { DateAdapter } from '@angular/material/core';
import {
  NavigationHeaderComponent,
  headerItem,
  HighchartContainerComponent,
} from '@standard-angular-utilities/shared-components';

@Component({
  selector: 'watermanager-base-root',
  templateUrl: './watermanager-base.component.html',
  styleUrl: './watermanager-base.component.css',
  imports: [
    RouterModule,
    RouterOutlet,
    NavigationHeaderComponent,
    HighchartContainerComponent,
  ],
})
export class WatermanagerBase {
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'bar',
    },
    title: {
      text: 'Fruit Consumption',
    },
    xAxis: {
      categories: ['Apples', 'Bananas', 'Oranges'],
    },
    yAxis: {
      title: {
        text: 'Fruit eaten',
      },
    },
    series: [
      {
        type: 'bar',
        data: [1, 2, 3],
      },
    ],
  }; // required
  routesAndNames: headerItem[] = [];

  constructor(
    private userService: UserService,
    private dateAdapter: DateAdapter<Date>
  ) {}

  get currentUser() {
    return this.userService.currentUser;
  }
}
